module.exports = __webpack_public_path__ + "static/img/280_TO8_2421_og.f3db0c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/280_TO8_2421_og.jpg
// module id = YmMo
// module chunks = 0